@import "../../../../globalStyles/commons";

.legal {
  margin-bottom: 0;
}
